import styled from 'styled-components';

export const Container = styled.div`
  margin: 20px 0 8px 0;

  label {
    display: flex;
    align-items: center;

    input {
      margin-right: 10px;
      cursor: pointer;

      &:disabled {
        cursor: not-allowed;
      }
    }
  }
`;
